export const sendPlausibleEvent = (msg: string): void => {
  if (window.plausible) {
    window.plausible(msg);
  }
};
